import { IColorConfig } from "../../types";

/**
 * 该文件用于配置某些组件的默认 props
 */

export const defaultGeoColor: IColorConfig = {
    defaultColor: 'wheat',
    activeColor: 'orange',
    hoverColor: 'skyblue',
    lockColor: '#8076a3'
}
